import { useState } from "react"
import { Switch } from "@stardust-ds/react"
import styles from "./index.module.scss"

export const SwitchSigma = ({ checked, onClick, isBlocked, className }) => {
  const [isChecked] = useState(checked)

  return (
    <div className={`${styles.switchContainer} ${className ? className : ""}`}>

    <Switch
      checked={ isChecked}
      onChange={(e) => {}}
      className={
        !isChecked || isBlocked ? styles.switchComponentDisabled : styles.switchComponent
      }
      // disabled={disabled}
      dataDisable={!isChecked ? "disabled" : "abled"}
      onClick={() => {
        onClick()
      }}
      />
    </div>
  )
}
